import React from "react";
import { Space, Descriptions, Card } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { PERMISSION_CONSTANT } from "../../../../../utils/constants/app";
import { connect } from "react-redux";
import { userhasPermissionHelper } from "../../../../../utils/Helpers";

const OrderPickNDrop = (props) => {
  const customerLoc = async (value)=>{
    return window.open(`https://maps.google.com/?q=${value.latitude},${value.longitude}`);
  }
  return (
    <Space direction="vertical" size="middle" style={{display: "flex",}}>
      <Card title="Pickup" bordered>
        <Descriptions className="listLabelBold">
          <Descriptions.Item label="Store" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].store.name ? props.orderData[0].store.name : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Store #" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].store.storeId ? props.orderData[0].store.storeId : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Location" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].pickup.address ? props.orderData[0].pickup.address : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Contact" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].pickup.phone ? props.orderData[0].pickup.phone : "-"}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <Card title="Drop Off" bordered>
        <Descriptions className="listLabelBold">
          <Descriptions.Item label="User Name" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].delivery.username ? props.orderData[0].delivery.username : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Location" span={3}>
            {(() => {
              const hasPermission = userhasPermissionHelper(
                props.permissions,
                PERMISSION_CONSTANT.VIEW_CUSTOMER_ADDRESS
              );

              const address =
                props.orderData?.[0]?.delivery?.address || "-";

              return hasPermission ? address : "-";
            })()}
          </Descriptions.Item>
          <Descriptions.Item label="Contact" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].delivery.phone_old_value ? props.orderData[0].delivery.phone_old_value : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="location pin" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].delivery.latitude && props.orderData[0].delivery.longitude ? <a onClick={()=>customerLoc(props.orderData[0].delivery)}><EnvironmentOutlined /></a>: "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Polygon #" span={3}>
            {props.orderData && props.orderData[0] && props.orderData[0].delivery.polygon_id ? props.orderData[0].delivery.polygon_id : "-"}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};
const mapStateToProps = (state) => {
  return {
    permissions: state.PermissionReducer.permissions,
  };
};
export default connect(mapStateToProps)(OrderPickNDrop);
